import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Loader, useLoader } from '@panel/commons/lib/Loader';
import { getMainColor, getOrangeColors } from '@panel/commons/lib/theme';
import { CompanyPubrSelectors } from '@panel/usuarios/src/store/ducks/myCompany';
import { userInfoSelectors } from '../state/ducks/user';
import { PublisherUnifiedBanner, SimpleBanner } from '../components/banner';
import { unifiedPanel } from '../constants/unifiedPanel';

const LoaderWrapper = styled.div`
  height: calc(100% + 100px);
  position: fixed;
  top: -100px;
  width: 100%;
  z-index: 5;
`;

const useBanner = () => {
  const site = process.env.REACT_APP_BUILD_SITE;
  const user = useSelector(userInfoSelectors.getuserInfoState);
  const { fetchedAutologin, autologin, loadingAutologin, generalDispatch, autologinFetchOneTimeOnly } = useSelector(
    CompanyPubrSelectors.getCompanyPubr
  );
  const [autologinState, setAutologinState] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [redir, setRedir] = useState(false);
  const { toggleLoader, setToggleLoader } = useLoader();

  useEffect(() => {
    if (unifiedPanel.includes(site)) {
      if (user.isPublisherMasked) {
        setShowBanner(true);
      }

      setToggleLoader(loadingAutologin);

      if (!autologinState && fetchedAutologin && autologin) {
        const uri = autologin;
        setAutologinState(uri.replace('configuracion.bum', 'panel.bum'));
      }

      if (autologinState && redir) {
        window.location = autologin;
      }
    }
  }, [
    autologinState,
    user.isPublisherMasked,
    autologin,
    fetchedAutologin,
    loadingAutologin,
    generalDispatch,
    setToggleLoader,
    redir,
    site
  ]);

  const BannerUnifiedPublisher = () => {
    const colors = {
      VAMX: getMainColor(),
      DVPE: getOrangeColors('darkerOrange')
    };
    return (
      <>
        <SimpleBanner background={colors[site]}>
          <PublisherUnifiedBanner setRedir={setRedir} autologinFetchOneTimeOnly={autologinFetchOneTimeOnly} />
        </SimpleBanner>
        {toggleLoader && (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        )}
      </>
    );
  };

  return { showBanner, autologin, BannerUnifiedPublisher };
};

export { useBanner };
